import type { IContext } from '../components/router/models';

/** Хелпер ищет router в котором есть route с именем name */
export const findRouterByName = <S>(router: IContext<S>, name: string) => {
    let foundRouter: IContext<S> | undefined = router;
    while (foundRouter && foundRouter.name !== name) foundRouter = foundRouter.parent;

    return foundRouter;
};
